/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable react/prop-types */

import React, { useState } from "react";
import { Transition } from "@headlessui/react";
import { useLocation } from "react-router-dom";

import Button from "../elements/Button";
import BrandIcon from "./BrandIcon";

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();
  const path = location.pathname;

  return (
    <header className="header">
      {/* Top Bar */}
      <div className="flex justify-between px-4 lg:px-0">
        {/* Logo + Tagline */}
        <div className="flex flex-col">
          <div>
            <BrandIcon />
          </div>

          <span className="pl-7 text-xs sm:text-sm font-medium text-theme-purple mt-1">
            India&apos;s First Curated Board Network
          </span>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="block text-theme-blue lg:hidden focus:outline-none"
          onClick={() => setIsCollapse(!isCollapse)}
        >
          <svg
            className="w-7 h-7"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              className={isCollapse ? "hidden" : "block"}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
            <path
              className={!isCollapse ? "hidden" : "block"}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Desktop Menu */}
      <ul className="hidden text-theme-purple tracking-wide items-center lg:flex flex-row mt-0 space-x-1 xl:space-x-4">
        <li>
          <Button
            className={`${path === "/" ? "active-link" : ""} font-medium text-xs xl:text-sm px-2 xl:px-3 whitespace-nowrap no-underline hover:underline`}
            type="link"
            href="/"
          >
            Home
          </Button>
        </li>

        <li>
          <Button
            className={`${path === "/" ? "active-link" : ""} font-medium text-xs xl:text-sm px-2 xl:px-3 whitespace-nowrap no-underline hover:underline`}
            type="link"
            href="/about-guvrn"
          >
            About Us
          </Button>
        </li>

        {/* Services Dropdown */}
        <li className="relative">
          <button
            className="font-medium text-xs xl:text-sm px-2 xl:px-3 whitespace-nowrap hover:underline flex items-center gap-1"
            onClick={() => setIsServicesOpen(!isServicesOpen)}
            onMouseEnter={() => setIsServicesOpen(true)}
            onMouseLeave={() => setIsServicesOpen(false)}
          >
            Why guvrn?
            <svg
              className={`w-3 h-3 transition-transform duration-200 ${isServicesOpen ? "rotate-180" : ""}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <Transition
            show={isServicesOpen}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <div
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
              className="absolute left-0 mt-1 w-40 bg-white border border-gray-200 shadow-lg rounded-md z-50"
            >
              <Button
                className="block w-full text-left px-3 py-1.5 text-sm text-theme-purple hover:bg-gray-100"
                type="link"
                href="/company-charter"
              >
                For Companies
              </Button>
              <Button
                className="block w-full text-left px-3 py-1.5 text-sm text-theme-purple hover:bg-gray-100"
                type="link"
                href="/charters"
              >
                For Independent Directors
              </Button>
            </div>
          </Transition>
        </li>

        <li>
          <Button
            className={`${path.startsWith("/blogs") ? "active-link" : ""}
             font-medium text-xs xl:text-sm px-2 xl:px-3 whitespace-nowrap no-underline hover:underline`}
            type="link"
            href="/guvrnspeak"
          >
            guvrnspeak
          </Button>
        </li>

        <li className="flex gap-2">
          <Button
            className="flex items-center justify-center font-medium text-xs xl:text-sm px-3 xl:px-5 py-1.5 whitespace-nowrap bg-theme-purple text-white rounded-full border border-theme-purple hover:bg-dark-theme-purple transition duration-200"
            type="link"
            href="/contact-guvrn"
          >
            Contact Us
          </Button>

          <Button
            className="flex items-center justify-center font-medium text-xs xl:text-sm px-3 xl:px-5 py-1.5 whitespace-nowrap bg-theme-purple text-white rounded-full border border-theme-purple hover:bg-dark-theme-purple transition duration-200"
            type="link"
            href="https://platform.guvrn.com/auth/jwt/register"
          >
            Sign Up
          </Button>
        </li>
      </ul>

      {/* Mobile Dropdown Menu */}
      <Transition
        show={isCollapse}
        enter="transition-opacity duration-400"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-400"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="transition duration-300 ease-in data-[closed]:opacity-0">
          <ul className="z-50 flex flex-col text-theme-blue tracking-wide my-4 absolute bg-white w-full border-b border-gray-300 lg:hidden space-y-3">
            <li className="py-1 bg-white">
              <Button className={`${path === "/" ? "active-link" : ""} font-medium px-6 no-underline hover:underline`} type="link" href="/">
                Home
              </Button>
            </li>

            <li className="py-1 bg-white">
              <Button className={`${path === "/about-guvrn" ? "active-link" : ""} font-medium px-6 no-underline hover:underline`} type="link" href="/about-guvrn">
                About Us
              </Button>
            </li>

            <li className="py-1 bg-white pb-2">
              <span className="font-medium px-6">Why guvrn?</span>
              <div className="pl-8 mt-1 space-y-1">
                <Button className="block font-normal no-underline hover:underline" type="link" href="/company-charter">
                  For Companies
                </Button>
                <Button className="block font-normal no-underline hover:underline" type="link" href="/charters">
                  For Independent Directors
                </Button>
              </div>
            </li>

            <li className="py-1 bg-white">
              <Button
                className={`${path.startsWith("/blogs") ? "active-link" : ""} 
                font-medium px-6 no-underline hover:underline`}
                type="link"
                href="/guvrnspeak"
              >
                guvrnspeak
              </Button>
            </li>

            <li className="mx-auto my-5 bg-white pb-3">
              <Button className="font-bold mx-auto px-4 py-1.5 bg-theme-purple text-white rounded-full border border-theme-purple hover:bg-dark-theme-purple transition duration-200" type="link" href="/contact-guvrn">
                Contact Us
              </Button>
            </li>

            <li className="mx-auto mb-5 bg-white pb-4">
              <Button className="font-bold mx-auto px-4 py-1.5 bg-theme-purple text-white rounded-full border border-theme-purple hover:bg-dark-theme-purple transition duration-200" type="link" href="https://platform.guvrn.com/auth/jwt/register">
                Sign Up
              </Button>
            </li>
          </ul>
        </div>
      </Transition>
    </header>
  );
}
